import React, { useEffect, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getUsuario } from '../../services/apiUsuario';
import MenuAdmin from './MenuAdmin';
import MenuUsuario from './MenuUsuario';

import './menuNavegacao.css';
const MenuNavegacao: React.FC = () => {
    const { isAuthenticated, logout } = useAuth();
    const location = useLocation();
    const dsLogin = localStorage.getItem('dsLogin');
    const cdPerfil = localStorage.getItem('cdPerfil');
    const cdUsuarioLogado = localStorage.getItem('cdUsuario');
    const [sexoUsuario, setSexoUsuario] = useState<String>();


    const formatarMensagemConformeSexo = () => {
        if (sexoUsuario === 'F' || sexoUsuario === 'f') {
            return 'a'
        }
        else if (sexoUsuario === 'M' || sexoUsuario === 'm') {
            return 'o'
        }
        else {
            return 'o'
        }
    }

    useEffect(() => {
        if (location.pathname === '/milshop/login') {
            return;
        }

        const buscarDadosUsuarioLogado = async () => {
            try {
                if (isAuthenticated) {
                    const response = await getUsuario(Number(cdUsuarioLogado));
                    setSexoUsuario(response.data.nmSexo);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuarioLogado();

    }, [location.pathname, cdUsuarioLogado]);
    const mensagemBoasVindas = `Bem vind${formatarMensagemConformeSexo()}, ${dsLogin}`;

    return isAuthenticated ? (
        <>
            <div className="d-flex align-items-center">
                <Dropdown>
                    <Dropdown.Toggle variant="primary" id="dropdown-basic">
                        <p style={{ color: 'var(--azul-branco)', marginBottom: '0', display: 'inline' }} className='me-3'>
                            {mensagemBoasVindas}
                        </p>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {cdPerfil === '1' && <MenuAdmin logout={logout} />}
                        {cdPerfil === '2' && <MenuUsuario logout={logout} />}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </>
    ) : (
        <Link to='/milshop/login' className='entrar'>
            Entrar
        </Link>
    );
};
export default MenuNavegacao;
